// Shared by the Community feed, video feed, and individual conversation pages.
// Following a conversation is a device preference, not a user-account subscription.
export const FOLLOWED_CONVERSATIONS_STORAGE_KEY = 'youdle-community-v5-followed-posts';
const MAX_FOLLOWED_CONVERSATIONS = 50;
const CONVERSATION_ID_PATTERN = /^[0-9a-f-]{36}$/i;

export function readFollowedConversationIds(storage: Pick<Storage, 'getItem'>): string[] {
  const raw = storage.getItem(FOLLOWED_CONVERSATIONS_STORAGE_KEY);
  if (!raw) return [];

  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return [];
  }
  if (!Array.isArray(parsed)) return [];

  return Array.from(new Set(parsed.filter(
    (id): id is string => typeof id === 'string' && CONVERSATION_ID_PATTERN.test(id),
  ))).slice(0, MAX_FOLLOWED_CONVERSATIONS);
}

export function toggleFollowedConversation(
  storage: Pick<Storage, 'getItem' | 'setItem'>,
  postId: string,
): string[] {
  if (!CONVERSATION_ID_PATTERN.test(postId)) {
    throw new Error('Invalid conversation ID');
  }

  const previous = readFollowedConversationIds(storage);
  const next = previous.includes(postId)
    ? previous.filter(id => id !== postId)
    : [postId, ...previous].slice(0, MAX_FOLLOWED_CONVERSATIONS);
  storage.setItem(FOLLOWED_CONVERSATIONS_STORAGE_KEY, JSON.stringify(next));
  return next;
}
